import { render, staticRenderFns } from "./SnackbarNotification.vue?vue&type=template&id=b653f0e2&scoped=true&"
import script from "./SnackbarNotification.vue?vue&type=script&lang=js&"
export * from "./SnackbarNotification.vue?vue&type=script&lang=js&"
import style0 from "./SnackbarNotification.vue?vue&type=style&index=0&id=b653f0e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b653f0e2",
  null
  
)

export default component.exports